module.exports = __webpack_public_path__ + "img/wegame.4bb42452.png";